'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import noAuthHttp from 'hub-http/clients/noAuthApiClient';

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, [{
    key: "makeGetRequest",
    value: function makeGetRequest(url, options) {
      return noAuthHttp.getWithResponse(url, options);
    }
  }, {
    key: "makePostRequest",
    value: function makePostRequest(url, options) {
      return noAuthHttp.post(url, options);
    }
  }]);

  return _default;
}();

export { _default as default };